import styled from "styled-components";

export const BodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export const HeaderContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    
    position: sticky;
    top: 24px;
    z-index: 120;
    width: 100%;
    
`;

export const SearchBarContainer = styled.div`
    max-width: 640px;
    width: 100%;
`;

export const FilterBarContainer = styled.div`
    display: flex;
    gap: 8px;
    max-width: 640px;
    width: 100%;

    & > * {
        flex: 1 1 0;
        min-width: 0;
    }
`;

export const LeftContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    min-width: 0;
`;

export const RightContainer = styled.div`
    width: 50%;
    min-width: 0;
    position: sticky;
    top: 24px;
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-height: calc(100vh - 48px);
    z-index: 120;
    overflow: hidden;
`;

export const SearchFiltersPanel = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    gap: 8px;
    width: 100%;
`;

export const QueuedCardsWrapper = styled.div`
    width: 100%;
    min-width: 0;
    min-height: 0;
    overflow-y: auto;
`;

export const ChecklistDisplayContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    min-width: 0;
    width: 100%;
`;

export const CardItemWrapper = styled.div`
    min-width: 0;
    width: 100%;

    & > * {
        width: 100% !important;
    }
`;
